import { msgTypes } from 'constants/msgTypes';
import { MembershipModel } from 'model/screensModels/membership/MembershipModel';
import { RequestModel } from 'model/utilModels/RequestModel';
import { useEffect, useState } from 'react';
import { UtilService } from 'services/shared/UtilService';
import './GeneratedCertificate.scss';

const GeneratedCertificate = ({ values, selectedCompanyName, certificateName , membershipType  }) => {

  const[CompanyData, setCompanyData] = useState( new MembershipModel());
  const [date, setDate] = useState("");
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov","Dec"]

  useEffect(() => {
    companyDetails();
    changeDateFormat();
  },[] )

  const companyDetails = async () => {
    const requestBody = new RequestModel();
    requestBody.companyId = values.companyId;
    const res = await UtilService.getCompanyDetailsByCompanyIdrequest(requestBody);
    
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setCompanyData(res.data)
    }
  };

  const changeDateFormat = ()=>{
    if(values.expireDate){
      const date = values.expireDate.split('-')
      const monthNumber = (Number(date[1])-1);
      
      setDate(date[2]+" "+months[monthNumber]+", "+date[0])
      
    }
  }

  return (
    <>
      <div className="certificate">
        <div className="left-banner">
          <img src="/images/certificate/1wn.png" alt="1WN Logo" />
        </div>
        <div className='certficate-logo-section'>
          <div className='certificate-text-heading'>
          <div className="header-text">CERTIFICATE <br /><span>OF MEMBERSHIP</span></div>
          </div>
          <div className='certificate-log-sec'>
            <img src="/images/1wn-logo.png" alt="" />
          </div>
        </div>
        <div className='certificate-map-img'>
          <div className="subheader-text">This is to certify that</div>

          <div className="certificate-content map-background">
           
          <p className="company-name">{certificateName || selectedCompanyName}</p>
          
            
            <p className='exclusive-member'> is the {membershipType} member of</p>
            <h1 className='network-heading'>ONE <span>WORLD</span> ONE <span>NETWORK</span></h1>
            <p className='year'>{date} (Valid upto)</p>
            
          </div>

          <div className="signature-section">
            <div>
              <img className='stamp-img' src="/images/certificate/stamp.png" alt="Stamp" />
            </div>
            <div className="signature">
              <img src="/images/certificate/sign.png" alt="Signature" />
              <p>Sunil Arora</p>
              <p>CEO</p>
            </div>
          </div>

          <div className="website-link">www.oneworldnetwork.co</div>
        </div>
      </div>

    
    </>
  )
}

export default GeneratedCertificate
